import React from 'react'
import Body from './Body'

const useGetCodesTypePopupInfo = (
  setTrackingType,
  setShowCodesExplanationPage,
) => {
  const title = 'What is your preferred method?'

  return {
    body: (
      <Body
        setTrackingType={setTrackingType}
        setShowCodesExplanationPage={setShowCodesExplanationPage}
      />
    ),
    footer: null,
    title: title,
  }
}

export default useGetCodesTypePopupInfo
